import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { SeeMoreText } from "..";
import { Icons, Images } from "../../assets";
import { Cred } from "../../models";
import { CollaboratorDetails } from "./collaborators-details";
import { CredInteractionDetails } from "./cred-interaction-details";
import { CredReccoDetails } from "./cred-recco-details";

type Props = {
  cred: Cred;
  handleGiveReccoClick: () => void;
  handleCredDetailsClicked: () => void;
};

export const CredCard: React.FC<Props> = ({
  cred,
  handleGiveReccoClick,
  handleCredDetailsClicked,
}) => {
  const [muted, setMuted] = useState<boolean>(true);

  const playPauseVideos = async (i: number) => {
    try {
      await (document.querySelector(`.video-${i}`) as HTMLVideoElement)?.play();
      document
        .querySelectorAll(".videos")
        .forEach(
          (video) =>
            video !== document.querySelector(`.video-${i}`) &&
            (video as HTMLVideoElement).pause()
        );
    } catch (e) {
      /* Handle Error */
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto bg-white rounded-2xl overflow-hidden">
      {cred && <CollaboratorDetails cred={cred} />}
      <SeeMoreText height={100} cls="my-2">{cred?.description}</SeeMoreText>

      {cred?.resources?.length ? (
        <Carousel
          autoPlay
          emulateTouch
          swipeable
          useKeyboardArrows
          showThumbs={false}
          showStatus={false}
          showArrows={false}
          className="w-full"
          onClickItem={(i) =>
            cred?.resources[i].type === "video" && setMuted((m) => !m)
          }
          onChange={playPauseVideos}
        >
          {cred?.resources.map((item, index) => (
            <div
              key={index}
              className="flex justify-center items-center w-full max-h-[calc(100vh-200px)] overflow-hidden"
            >
              {item.type === "video" ? (
                <>
                  <video
                    src={item.url}
                    className={`videos video-${index} object-cover w-full h-auto max-h-[calc(100vh-250px)]`}
                    muted={muted}
                    playsInline
                    autoPlay
                    loop
                  />
                  <img
                    src={muted ? Icons.SOUND_OFF : Icons.SOUND_ON}
                    alt="Toggle Mute"
                    className="absolute left-[212px] bottom-4 w-8 h-8 cursor-pointer"
                    onClick={() => setMuted((m) => !m)}
                  />
                </>
              ) : (
                <img
                  src={item.url}
                  alt="Recco Media"
                  className="w-full h-auto object-cover max-h-[calc(100vh-250px)]"
                />
              )}
            </div>
          ))}
        </Carousel>
      ) : (
        <div className="w-full flex justify-center items-center p-4">
          <img src={Images.RECCO_PLACEHOLDER} alt="Placeholder" className="w-full max-h-96" />
        </div>
      )}

      <CredInteractionDetails
        cred={cred}
        handleCredDetailsClicked={handleCredDetailsClicked}
      />

      <div
        className={`flex py-2 w-full items-center ${
          cred?.reccoCount > 0 ? "justify-between" : "justify-end"
        } border-t border-gray-200`}
      >
        {cred?.reccoCount > 0 && (
          <CredReccoDetails
            cred={cred}
            handleCredDetailsClicked={handleCredDetailsClicked}
          />
        )}
        <button
          className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition"
          onClick={handleGiveReccoClick}
        >
          <img src={Icons.RECCO_WHITE_LOGO} alt="Recco" className="w-6 h-6" />
          <span>Give Recco</span>
        </button>
      </div>
    </div>
  );
};
